var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 52,
    viewBox: "0 0 40 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1937_39470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5 11.9854V48.0063C39.5 50.2132 37.5747 52.0001 35.1975 52.0001H9.24937C6.87216 52.0001 4.94684 50.2132 4.94684 48.0063V8.49179C4.94684 6.28487 6.87216 4.49414 9.24937 4.49414H30.3975L39.5 11.9893V11.9854Z",
    fill: "#D4DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8127 8.25879V44.2758C35.8127 46.4827 33.8874 48.2697 31.5102 48.2697H5.56205C3.18484 48.2697 1.25952 46.4827 1.25952 44.2758V4.76132C1.25952 2.55441 3.18484 0.763672 5.56205 0.763672H26.7102L35.8127 8.25879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5101 49.0333H5.56203C2.77089 49.0333 0.5 46.8989 0.5 44.2758V4.76129C0.5 2.13437 2.77089 0 5.56203 0H26.7101C26.8848 0 27.0557 0.0610911 27.1924 0.171819L36.2949 7.66694C36.4696 7.81203 36.5722 8.02966 36.5722 8.25876V44.2758C36.5722 46.8989 34.3013 49.0333 31.5101 49.0333ZM5.56203 1.52728C3.61013 1.52728 2.01899 2.97819 2.01899 4.76129V44.2758C2.01899 46.0589 3.61013 47.506 5.56203 47.506H31.5101C33.462 47.506 35.0532 46.0589 35.0532 44.2758V8.61767L26.4405 1.52728H5.56203Z",
    fill: "#4365E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5304 21.455H9.29115C8.58482 21.455 8.0152 21.1114 8.0152 20.6914C8.0152 20.2714 8.58862 19.9277 9.29115 19.9277H27.5304C28.2367 19.9277 28.8063 20.2714 28.8063 20.6914C28.8063 21.1114 28.2329 21.455 27.5304 21.455Z",
    fill: "#4365E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5304 25.8144H9.29115C8.58482 25.8144 8.0152 25.4707 8.0152 25.0507C8.0152 24.6307 8.58862 24.2871 9.29115 24.2871H27.5304C28.2367 24.2871 28.8063 24.6307 28.8063 25.0507C28.8063 25.4707 28.2329 25.8144 27.5304 25.8144Z",
    fill: "#4365E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2317 30.1796H9.29115C8.58482 30.1796 8.0152 29.836 8.0152 29.416C8.0152 28.996 8.58862 28.6523 9.29115 28.6523H20.2355C20.9418 28.6523 21.5114 28.996 21.5114 29.416C21.5114 29.836 20.938 30.1796 20.2355 30.1796H20.2317Z",
    fill: "#4365E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7101 0.763672V8.22061H35.8127L26.7101 0.763672Z",
    fill: "#D4DBEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8126 8.98508H26.7101C26.2924 8.98508 25.9506 8.64144 25.9506 8.22144V0.764504C25.9506 0.470503 26.1177 0.199411 26.3835 0.0734104C26.6494 -0.0525901 26.9607 -0.0144081 27.1886 0.172683L36.2911 7.62962C36.5418 7.8358 36.6329 8.1718 36.5266 8.47726C36.4202 8.78271 36.1316 8.98508 35.8126 8.98508ZM27.4696 7.4578H33.6785L27.4696 2.37196V7.4578Z",
    fill: "#4365E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1937_39470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 52,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.97a1c337728acc9a4a3af17ab1cac01a.svg";
export { ForwardRef as ReactComponent };